export default __webpack_public_path__ + "vision-safety-alerts-drawing-thumbnail-960-9457f6f984d805f9854149ccc615b4e3.png";